const sign = require('jwt-encode');
const secret = process.env.VUE_APP_KEY_JW;

/**
 * @class Jwt
 * @brief Gestiona las operaciones de codificación y decodificación JWT.
 */
class Jwt {
    /**
     * @brief Codifica datos en un token JWT.
     *
     * @param data Datos a codificar.
     *
     * @returns {string} Token JWT generado.
     */
    jwtEncode(data) {
        const jwt = sign(data, secret);
        return jwt;
    }

    /**
     * @brief Codifica datos JSON en un token JWT.
     *
     * @param data Objeto JSON a codificar.
     *
     * @returns {string} Token JWT generado.
     */
    jwtEncodeJson(data) {
        const jwt = sign(data, secret);
        return jwt;
    }

    /**
     * @brief Decodifica un token JWT y extrae los datos originales.
     *
     * @param jwt Token JWT a decodificar.
     *
     * @returns {Object} Objeto con los datos decodificados.
     */
    jwtDecode(jwt) {
        let base64Url = jwt.split('.')[1];
        let base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/');
        let jsonPayload = decodeURIComponent(globalThis.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.codePointAt(0).toString(16)).slice(-2);
        }).join(''));
        let json = JSON.parse(jsonPayload).Content;
        base64 = json.replaceAll('-', '+').replaceAll('_', '/');
        jsonPayload = decodeURIComponent(globalThis.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.codePointAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }

    /**
     * @brief Decodifica un mensaje SMS codificado con JWT.
     *
     * @param sms Mensaje SMS codificado con JWT.
     *
     * @returns {Object} Objeto con los datos del mensaje decodificado.
     */
    jwtDecodeSms(sms) {
        let base64Url = sms.split('.')[1];
        let base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/');
        let jsonPayload = decodeURIComponent(globalThis.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.codePointAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    /**
     * @brief Prueba de decodificación de un token JWT.
     *
     * @param jwt Token JWT a probar.
     *
     * @returns {Object} Objeto con los datos del token decodificado.
     */
    jwtTest(jwt) {
        let base64Url = jwt.split('.')[1];
        let base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/');
        let jsonPayload = decodeURIComponent(globalThis.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.codePointAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }
}
export default new Jwt();